<template>
  <Modal
    v-model="_value"
    width="500"
    title="指定业务跟进"
    @on-visible-change="visibleChange"
    ok-text="修改"
    @on-ok="onOk">
    <Form style="display: inline;">
      <FormItem label="业务人员">
        <Select style="display: inline-block; width: 200px;"
                v-model="selectBusinessUserId">
          <Option v-for="item in businessUsers" :value="item.id" :key="item.realName != null?item.realName:item.nickName != null?item.nickName:item.name">{{item.realName != null?item.realName:item.nickName != null?item.nickName:item.name}}</Option>
        </Select>
      </FormItem>

      <FormItem label="三方监控续费同步">
<!--        <Select style="display: inline-block; width: 200px;"-->
<!--                v-model="selectBusinessUserId">-->
<!--          <Option v-for="item in businessUsers" :value="item.id" :key="item.realName != null?item.realName:item.nickName != null?item.nickName:item.name">{{item.realName != null?item.realName:item.nickName != null?item.nickName:item.name}}</Option>-->
<!--        </Select>-->
        <RadioGroup v-model="monitoringServicetype">
          <Radio label='是'></Radio>
          <Radio label='否'></Radio>
        </RadioGroup>
      </FormItem>
    </Form>
  </Modal>
</template>
<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'BusinessNoteDetailModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initValue: null
  },
  data () {
    return {
      businessState: [
        { label: '待开发', value: 1 },
        // {label: '在网', value: 2},
        { label: '继续沟通', value: 3 },
        { label: '沟通未果', value: 4 },
        // {label: '待安装', value: 5},
        // {label: '待拆机', value: 6},
        // {label: '待收款', value: 7},
        // {label: '服务到期', value: 8},
        // {label: '离网', value: 9},
        // {label: '准备到期', value: 10}
        { label: '同意入网', value: 11 }
      ],

      marketSalesId: 7,

      // 当前车辆信息id
      vehicleInfoId: null,

      // 业务员列表
      businessUsers: [],
      selectBusinessUserId: null,
      monitoringServicetype: '否'
    }
  },
  methods: {
    ...mapActions([
      'BusinessNoteServ_GetDetail',
      'BusinessNoteServ_ModifyObj',
      'BusinessNoteServ_AddObj'
    ]),
    formatDate (val) {
      if (val) {
        let d = new Date(val)
        return d.Format('yyyy年MM月dd日 hh:mm:ss')
      } else {
        return '无'
      }
    },
    onOk () {
      if (this.monitoringServicetype == '是') {
        this.monitoringServicetype = true
      } else {
        this.monitoringServicetype = false
      }
      this.$Modal.confirm({
        title: '确认修改指定业务跟进',
        content: '<p>确认修改指定业务跟进</p>',
        onOk: () => {
          store.dispatch('VehicleInfoServ_ChangeBusinessUser', {
            params: {
              id: this.vehicleInfoId,
              userId: this.selectBusinessUserId,
              monitoringServicetype: this.monitoringServicetype
            }
          }).then(() => {
            this.$Message.success('修改成功')
            this.$emit('on-success')
          }).catch(err => {
            this.$Message.error(err)
          })
        },
        onCancel: () => {

        }
      })
    },
    visibleChange (val) {
      if (val) {
        this.businessUsers = []
        this.selectBusinessUserId = null
        let vehicleInfoId = this._initValue
        if (vehicleInfoId) {
          this.vehicleInfoId = vehicleInfoId
          store.dispatch('UserServ_GetAllUsers', {
            params: {},
            urlparams: { roleIds: [7] }
          }).then(() => {
            this.businessUsers = store.getters.get_User_GetAllUsersResult
            console.log(this.businessUsers)
            store.dispatch('VehicleInfoServ_GetDetail', {
              params: { id: vehicleInfoId }
            }).then(() => {
              this.selectBusinessUserId = store.getters.get_VehicleInfo_GetDetailResult.businessUserId
            }).catch(err => {
              this.$Message.error(err)
            })
          }).catch(err => {
            this.$Message.error(err)
          })
        }
      }
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
